import { UPDATE_KYC_STATE_FAILURE, UPDATE_KYC_STATE_REQUEST, UPDATE_KYC_STATE_RESET, UPDATE_KYC_STATE_SUCCESS } from "@/redux/actions";
const initialState = {
    data: null,
    loading: false,
    error: null,
};
const updateKYCstateReducer = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_KYC_STATE_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, data: action.payload });
        case UPDATE_KYC_STATE_REQUEST:
            return Object.assign(Object.assign({}, state), { loading: true, data: null, error: null });
        case UPDATE_KYC_STATE_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload });
        case UPDATE_KYC_STATE_RESET:
            return Object.assign(Object.assign({}, state), { loading: false, data: null, error: null });
        default:
            return state;
    }
};
export default updateKYCstateReducer;
